import React, { useContext } from 'react';
import './RoomAmenities.css';
import { LanguageContext } from '../context/LanguageContext';


const RoomAmenities = ({ amenities }) => {
  const {t} = useContext(LanguageContext);
  return (
    <section className="room-amenities">
      <h2 className="amenities-title">{t("roomDetail","roomAmenities")}</h2>
      
      <div className="amenities-grid">
        {amenities.map((amenity, index) => (
          <div key={index} className="amenity-item">
            <span className="material-symbols-outlined notranslate amenity-icon">
              {amenity.icon}
            </span>
            <span>{amenity.text}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default RoomAmenities;